class UserAgent {
  private _info: string
  private _appType = 0
  private _appVersion = [] as number[]

  constructor (deviceInfo: string) {
    this._info = deviceInfo
    const match = this._info.match(/NetatmoApp\/v([012])\.([0-9]+)(\.([0-9]+)(\.([0-9]*))?)?/)

    if (match !== null) {
      const app = match.map(Number)
      // First digit is app type
      this._appType = app[1]

      // Major version
      this._appVersion = [app[2]]

      // Minor version
      if (typeof app[4] !== 'undefined') {
        this._appVersion.push(app[4])

        // Patch version
        if (typeof app[6] !== 'undefined') {
          this._appVersion.push(app[6])
        }
      }
    }
  }

  getInfo () {
    return this._info
  }

  getAppVersion () {
    return this._appVersion
  }

  getAppType () {
    return this._appType
  }

  isNativeApp () {
    return (/NetatmoApp/i.test(this._info))
  }

  isMobile () {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(this._info))
  }

  isIos () {
    return this._appType === 0 || (/iPhone|iPad|iPod/i.test(this._info))
  }

  isIphoneX () {
    // Get the device pixel ratio
    const ratio = window.devicePixelRatio || 1
    return this.isIos() && (window.screen.width * ratio) === 1125 && (window.screen.height * ratio) === 2436
  }

  isAndroid () {
    return this._appType === 1 || (/Android/i.test(this._info))
  }

  iosVersion () {
    return this._info.substr(this._info.indexOf('OS') + 2, 2)
  }
}

export default UserAgent
